import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLexoMeShumIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 19.2,
	viewBox: "0 0 40 19.2",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "read_more_FILL1_wght400_GRAD0_opsz48",
		d: "M18.85,25.5H5.5a1.5,1.5,0,1,1,0-3H18.85l-5.5-5.55a1.639,1.639,0,0,1-.425-1.05,1.354,1.354,0,0,1,.425-1.05,1.45,1.45,0,0,1,2.1,0l8.1,8.1a1.45,1.45,0,0,1,0,2.1l-8.1,8.1a1.45,1.45,0,0,1-2.1,0,1.354,1.354,0,0,1-.425-1.05,1.639,1.639,0,0,1,.425-1.05Zm9.65-8a1.5,1.5,0,1,1,0-3h14a1.5,1.5,0,1,1,0,3Zm0,16a1.5,1.5,0,1,1,0-3h14a1.5,1.5,0,1,1,0,3Zm6-8a1.5,1.5,0,1,1,0-3h8a1.5,1.5,0,1,1,0,3Z",
		transform: "translate(-4 -14.4)"
	})
});
export { SvgLexoMeShumIcon as ReactComponent };
